import { Constants, effectsVolume } from "@core/Utils/Constants"
import { HelpScreen, Page } from "@core/GUI/Pages/HelpScreen";
import { Language, Messages } from "@core/GUI/Language";
import { Assets } from "@core/GUI/Utils/Assets";
import { BetType } from "@core/Logic/BetStake";
import { Client } from "@core/Client";

export class BaseRouletteHelpScreen extends HelpScreen {
    protected boardButtonDisplayWidth: number = 0;
    protected trackScale: number = 1;
    protected generalOffsetY: number = this.trackScale * Constants.TRACK.OFFSET_DUE_TO_ORIGIN;
    protected textPadding: number;
    protected textSpace: number;
    protected unitedTitleFontSize: string = "33px";
    protected unitedBodyFontSize: string = "32px";
    protected trackNumbers: Array<number> = [0, 32, 15, 19, 4, 21, 26, 3, 35, 12, 28, 7, 29, 18, 22, 9, 31, 14, 20, 1, 33, 16, 24, 5, 10, 23, 8, 30, 11, 36, 13, 27, 6, 34, 17, 25, 2, 37]
    protected circleSize: number;

    constructor(protected scene: Phaser.Scene) {
        super(scene);

        this.addPlayerInterfacePage();
        this.addPlayerTrackPage();
        this.addTopPanelPage();
        this.addBetsPage();
        this.addExtrasPage();

        // * ADDING PAGES AND SUBTITLES
        this.subTitles = new Array<Phaser.GameObjects.Text>();
        this.pages.forEach((page, index) => {
            this.subTitles.push((new Phaser.GameObjects.Text(this.scene, 0, 0, page.getPageName(), {
                fontFamily: 'Arial',
                fontSize: '42px',
                color: '#ffffff',
                align: 'center'
            })).setData('message', () => (page.getPageName)));
            this.subTitles[index].setInteractive();
            this.subTitles[index].on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
                event.stopPropagation();
                if (this.activePage != index) {
                    this.scene.sound.play(Constants.SOUNDS.CHIP_SELECT, { volume: 0.45 * effectsVolume });
                    this.activePage = index;
                    this.UpdateSubtitle();
                }
            }, this);
            this.subTitles[index].visible = false;

            this.scene.children.add(this.subTitles[index]);
            this.scene.children.add(page.container);
            page.container.visible = false;
            page.container.active = false;
        });

        this.UpdateSubtitle();
    }

    public addPlayerInterfacePage(): void {
        let playerInterfacePage = new Page(() => (Language.Get(Messages.HELP_PLAYER_INTERFACE)), new Phaser.GameObjects.Container(this.scene, 0, 0))
        this.pages.push(playerInterfacePage);

        playerInterfacePage.container.setSize(1920, 1080);
        //----------draw board------------------------------------------------------------------------------------------------------------
        this.boardButtonDisplayWidth = playerInterfacePage.container.width / 17;

        let tableOffset = (1920 - this.boardButtonDisplayWidth * 14) / 2

        //--draw zero and/or double zero----------
        if (Client.logic.IsDoubleZero()) {
            let zeroButton = new Phaser.GameObjects.Image(this.scene, tableOffset, 0, Constants.SPRITESHEET, "board_button_00_00.png");
            zeroButton.setOrigin(0, 0);
            zeroButton.setDisplaySize(this.boardButtonDisplayWidth, this.boardButtonDisplayWidth * (zeroButton.displayHeight / zeroButton.displayWidth));

            let doubleZeroButton = new Phaser.GameObjects.Image(this.scene, zeroButton.x, zeroButton.y + zeroButton.displayHeight, Constants.SPRITESHEET, "board_button_00_0.png");
            doubleZeroButton.setOrigin(0, 0);
            doubleZeroButton.setDisplaySize(zeroButton.displayWidth, zeroButton.displayHeight);

            playerInterfacePage.container.add(zeroButton);
            playerInterfacePage.container.add(doubleZeroButton);
        } else {
            let zeroButton = new Phaser.GameObjects.Image(this.scene, tableOffset, 0, Constants.SPRITESHEET, "board_button_0.png");
            zeroButton.setOrigin(0, 0);
            zeroButton.setDisplaySize(this.boardButtonDisplayWidth, this.boardButtonDisplayWidth * (zeroButton.displayHeight / zeroButton.displayWidth));

            playerInterfacePage.container.add(zeroButton);
        }
        //--draw numbers-----------------------------
        let myNum = 1;
        for (let i = 0; i < 12; i++) {
            for (let j = 3; j > 0; j--) {
                let field = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + myNum + ".png")
                field.setOrigin(0, 0)
                field.setPosition(tableOffset + this.boardButtonDisplayWidth * (1 + i), (this.boardButtonDisplayWidth * (field.displayHeight / field.displayWidth)) * (j - 1));
                field.setDisplaySize(this.boardButtonDisplayWidth, this.boardButtonDisplayWidth * (field.displayHeight / field.displayWidth));
                playerInterfacePage.container.add(field);
                myNum++;
            }
        }

        //--draw thirds/red/black/pairs/...----------
        let field_firstThird = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.FIRST_THIRD + ".png")
        field_firstThird.setOrigin(0, 0)
        if (Client.logic.IsDoubleZero())
            field_firstThird.x = (playerInterfacePage.container.list[2] as Phaser.GameObjects.Image).x;
        else
            field_firstThird.x = (playerInterfacePage.container.list[1] as Phaser.GameObjects.Image).x;
        field_firstThird.y = (playerInterfacePage.container.list[2] as Phaser.GameObjects.Image).displayHeight * 3;
        field_firstThird.setDisplaySize(this.boardButtonDisplayWidth * 4, this.boardButtonDisplayWidth * 4 * (field_firstThird.displayHeight / field_firstThird.displayWidth));
        playerInterfacePage.container.add(field_firstThird);

        let field_secondThird = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.SECOND_THIRD + ".png")
        field_secondThird.setOrigin(0, 0)
        field_secondThird.x = field_firstThird.x + field_firstThird.displayWidth;
        field_secondThird.y = field_firstThird.y;
        field_secondThird.setDisplaySize(field_firstThird.displayWidth, field_firstThird.displayHeight);
        playerInterfacePage.container.add(field_secondThird);

        let field_thirdThird = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.THIRD_THIRD + ".png")
        field_thirdThird.setOrigin(0, 0)
        field_thirdThird.x = field_firstThird.x + field_firstThird.displayWidth * 2;
        field_thirdThird.y = field_firstThird.y;
        field_thirdThird.setDisplaySize(field_firstThird.displayWidth, field_firstThird.displayHeight);
        playerInterfacePage.container.add(field_thirdThird);

        let field_firstHalf = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.FIRST_HALF + ".png")
        field_firstHalf.setOrigin(0, 0)
        field_firstHalf.x = field_firstThird.x;
        field_firstHalf.y = field_firstThird.y + field_firstThird.displayHeight;
        field_firstHalf.setDisplaySize(this.boardButtonDisplayWidth * 2, this.boardButtonDisplayWidth * 2 * (field_firstHalf.displayHeight / field_firstHalf.displayWidth));
        playerInterfacePage.container.add(field_firstHalf);

        let field_even = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.EVEN + ".png")
        field_even.setOrigin(0, 0)
        field_even.x = field_firstHalf.x + field_firstHalf.displayWidth;
        field_even.y = field_firstHalf.y;
        field_even.setDisplaySize(field_firstHalf.displayWidth, field_firstHalf.displayHeight);
        playerInterfacePage.container.add(field_even);

        let field_red = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.RED + ".png")
        field_red.setOrigin(0, 0)
        field_red.x = field_even.x + field_even.displayWidth;
        field_red.y = field_firstHalf.y;
        field_red.setDisplaySize(field_firstHalf.displayWidth, field_firstHalf.displayHeight);
        playerInterfacePage.container.add(field_red);

        let field_black = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.BLACK + ".png")
        field_black.setOrigin(0, 0)
        field_black.x = field_red.x + field_red.displayWidth;
        field_black.y = field_firstHalf.y;
        field_black.setDisplaySize(field_firstHalf.displayWidth, field_firstHalf.displayHeight);
        playerInterfacePage.container.add(field_black);

        let field_odd = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.ODD + ".png")
        field_odd.setOrigin(0, 0)
        field_odd.x = field_black.x + field_black.displayWidth;
        field_odd.y = field_firstHalf.y;
        field_odd.setDisplaySize(field_firstHalf.displayWidth, field_firstHalf.displayHeight);
        playerInterfacePage.container.add(field_odd);

        let field_secondHalf = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.SECOND_HALF + ".png")
        field_secondHalf.setOrigin(0, 0)
        field_secondHalf.x = field_odd.x + field_odd.displayWidth;
        field_secondHalf.y = field_firstHalf.y;
        field_secondHalf.setDisplaySize(field_firstHalf.displayWidth, field_firstHalf.displayHeight);
        playerInterfacePage.container.add(field_secondHalf);

        let field_firstTwelve = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.TWELVE_ONE + ".png")
        field_firstTwelve.setOrigin(0, 0)
        field_firstTwelve.x = (playerInterfacePage.container.list[0] as Phaser.GameObjects.Image).x + (playerInterfacePage.container.list[0] as Phaser.GameObjects.Image).displayWidth * 13;
        field_firstTwelve.y = (playerInterfacePage.container.list[0] as Phaser.GameObjects.Image).y;
        field_firstTwelve.setDisplaySize((playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayWidth, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight);
        playerInterfacePage.container.add(field_firstTwelve);

        let field_secondTwelve = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.TWENTY_ONE_ONE + ".png")
        field_secondTwelve.setOrigin(0, 0)
        field_secondTwelve.x = field_firstTwelve.x;
        field_secondTwelve.y = field_firstTwelve.y + field_firstTwelve.displayHeight;
        field_secondTwelve.setDisplaySize(field_firstTwelve.displayWidth, field_firstTwelve.displayHeight);
        playerInterfacePage.container.add(field_secondTwelve);

        let field_thirdTwelve = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + Constants.BOARD.BOARD_BUTTON_NAMES.THIRTY_TWO_ONE + ".png")
        field_thirdTwelve.setOrigin(0, 0)
        field_thirdTwelve.x = field_firstTwelve.x;
        field_thirdTwelve.y = field_secondTwelve.y + field_secondTwelve.displayHeight;
        field_thirdTwelve.setDisplaySize(field_firstTwelve.displayWidth, field_firstTwelve.displayHeight);
        playerInterfacePage.container.add(field_thirdTwelve);
        //--draw misc buttons around board----------
        let field_repeat = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "button_repeat_bets.png");
        field_repeat.setOrigin(0, 0)
        field_repeat.x = (playerInterfacePage.container.list[0] as Phaser.GameObjects.Image).x;
        field_repeat.y = field_firstThird.y;
        field_repeat.setDisplaySize((playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayWidth, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 0.93);
        playerInterfacePage.container.add(field_repeat);
        let repeatText = new Phaser.GameObjects.Text(this.scene, field_repeat.x + field_repeat.displayWidth / 2, field_repeat.y + field_repeat.displayHeight / 1.35, Language.Get(Messages.REPEAT), Constants.BOARD.MISC_BUTTON_FONT)
        repeatText.setOrigin(0.5)
        repeatText.scale = field_repeat.scale;
        playerInterfacePage.container.add(repeatText);

        let field_undo = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "button_undo.png");
        field_undo.setOrigin(0, 0)
        field_undo.x = field_repeat.x;
        field_undo.y = field_firstHalf.y;
        field_undo.setDisplaySize(field_repeat.displayWidth, field_repeat.displayHeight);
        playerInterfacePage.container.add(field_undo);
        let undoText = new Phaser.GameObjects.Text(this.scene, field_undo.x + field_undo.displayWidth / 2, field_undo.y + field_undo.displayHeight / 1.35, Language.Get(Messages.UNDO), Constants.BOARD.MISC_BUTTON_FONT)
        undoText.setOrigin(0.5)
        undoText.scale = field_undo.scale;
        playerInterfacePage.container.add(undoText);

        let field_trackLayout = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "button_track.png");
        field_trackLayout.setOrigin(0, 0)
        field_trackLayout.x = field_thirdTwelve.x;
        field_trackLayout.y = field_repeat.y;
        field_trackLayout.setDisplaySize(field_repeat.displayWidth, field_repeat.displayHeight);
        playerInterfacePage.container.add(field_trackLayout);
        let trackLayoutText = new Phaser.GameObjects.Text(this.scene, field_trackLayout.x + field_trackLayout.displayWidth / 2, field_trackLayout.y + field_trackLayout.displayHeight / 1.35, Language.Get(Messages.TRACK_LAYOUT), Constants.BOARD.MISC_BUTTON_FONT)
        trackLayoutText.setOrigin(0.5)
        trackLayoutText.scale = field_trackLayout.scale;
        playerInterfacePage.container.add(trackLayoutText);

        let field_betPresets = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "button_presets.png");
        field_betPresets.setOrigin(0, 0)
        field_betPresets.x = field_trackLayout.x;
        field_betPresets.y = field_undo.y;
        field_betPresets.setDisplaySize(field_repeat.displayWidth, field_repeat.displayHeight);
        playerInterfacePage.container.add(field_betPresets);
        let betPresetsText = new Phaser.GameObjects.Text(this.scene, field_betPresets.x + field_betPresets.displayWidth / 2, field_betPresets.y + field_betPresets.displayHeight / 2, Language.Get(Messages.PRESETS), Constants.BOARD.MISC_BUTTON_FONT)
        betPresetsText.setOrigin(0.5)
        betPresetsText.scale = (field_betPresets.displayWidth * 0.90) / betPresetsText.displayWidth
        playerInterfacePage.container.add(betPresetsText);
        //----------draw chips and color rectangles--------------------------------------------------------------------------------------------------
        this.textPadding = playerInterfacePage.container.width / 600;
        this.textSpace = playerInterfacePage.container.width / 6 - this.textPadding;
        //trio
        let chip_trio = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip3_N.png");
        chip_trio.setOrigin(0.5)
        chip_trio.x = tableOffset + this.boardButtonDisplayWidth * 3.5;
        chip_trio.y = field_firstThird.y;
        chip_trio.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
        playerInterfacePage.container.add(chip_trio);
        let trio_rectangle = new Phaser.GameObjects.Rectangle(this.scene, tableOffset + this.boardButtonDisplayWidth * 3, 0, this.boardButtonDisplayWidth, chip_trio.y, 0x99ff33, 0.4);
        trio_rectangle.setStrokeStyle(3, trio_rectangle.fillColor, 1.0)
        trio_rectangle.setOrigin(0, 0);
        playerInterfacePage.container.add(trio_rectangle);

        let trioTextTitle = new Phaser.GameObjects.Text(this.scene, this.textSpace + this.textPadding * 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_TRIO_TITLE), {
            fontFamily: 'Arial',
            fontSize: this.unitedTitleFontSize,
            color: '#99ff33',
            align: 'left',
            stroke: '#99ff33',
            strokeThickness: 1,
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let trioTextBody = new Phaser.GameObjects.Text(this.scene, this.textSpace + this.textPadding * 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_TRIO_BODY), {
            fontFamily: 'Arial',
            fontSize: this.unitedBodyFontSize,
            color: '#ffffff',
            align: 'left',
            wordWrap: {
                width: this.textSpace,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let trioPays = this.GeneratePaysTextObject(this.textSpace + this.textPadding * 2, 36 + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextBody.displayHeight * 1.1, Client.logic.bets.betTypes[BetType.BET_TRASV].Multiplier, this.textSpace);
        playerInterfacePage.container.add(trioTextTitle);
        playerInterfacePage.container.add(trioTextBody);
        playerInterfacePage.container.add(trioPays);
        //six numbers
        let chip_six = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip4_N.png");
        chip_six.setOrigin(0.5)
        chip_six.x = tableOffset + this.boardButtonDisplayWidth * 6;
        chip_six.y = field_firstThird.y;
        chip_six.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
        playerInterfacePage.container.add(chip_six);
        let six_rectangle = new Phaser.GameObjects.Rectangle(this.scene, tableOffset + this.boardButtonDisplayWidth * 5, 0, this.boardButtonDisplayWidth * 2, chip_six.y, 0xff00ff, 0.33);
        six_rectangle.setStrokeStyle(3, six_rectangle.fillColor, 1.0)
        six_rectangle.setOrigin(0, 0);
        playerInterfacePage.container.add(six_rectangle);

        let sixNumbersTextTitle = new Phaser.GameObjects.Text(this.scene, this.textSpace * 2 + this.textPadding * 3, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_SIX_NUMBERS_TITLE), {
            fontFamily: 'Arial',
            fontSize: this.unitedTitleFontSize,
            color: '#ff00ff',
            align: 'left',
            stroke: '#ff00ff',
            strokeThickness: 1,
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let sixNumbersTextBody = new Phaser.GameObjects.Text(this.scene, this.textSpace * 2 + this.textPadding * 3, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_SIX_NUMBERS_BODY), {
            fontFamily: 'Arial',
            fontSize: this.unitedBodyFontSize,
            align: 'left',
            color: '#ffffff',
            wordWrap: {
                width: this.textSpace,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let sixNumbersPays = this.GeneratePaysTextObject(this.textSpace * 2 + this.textPadding * 3, 36 + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + sixNumbersTextBody.displayHeight * 1.1, Client.logic.bets.betTypes[BetType.BET_SIXTH].Multiplier, this.textSpace);
        playerInterfacePage.container.add(sixNumbersTextTitle);
        playerInterfacePage.container.add(sixNumbersTextBody);
        playerInterfacePage.container.add(sixNumbersPays);
        //corner
        let chip_corner = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip5_N.png");
        chip_corner.setOrigin(0.5)
        chip_corner.x = tableOffset + this.boardButtonDisplayWidth * 9;
        chip_corner.y = (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2;
        chip_corner.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
        playerInterfacePage.container.add(chip_corner);
        let corner_rectangle = new Phaser.GameObjects.Rectangle(this.scene, tableOffset + this.boardButtonDisplayWidth * 8, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight, this.boardButtonDisplayWidth * 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2, 0x3399ff, 0.33);
        corner_rectangle.setStrokeStyle(3, corner_rectangle.fillColor, 1.0)
        corner_rectangle.setOrigin(0, 0);
        playerInterfacePage.container.add(corner_rectangle);

        let CornerTextTitle = new Phaser.GameObjects.Text(this.scene, this.textSpace * 3 + this.textPadding * 4, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_CORNER_TITLE), {
            fontFamily: 'Arial',
            fontSize: this.unitedTitleFontSize,
            color: '#3399ff',
            align: 'left',
            stroke: '#3399ff',
            strokeThickness: 1,
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let CornerTextBody = new Phaser.GameObjects.Text(this.scene, this.textSpace * 3 + this.textPadding * 4, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_CORNER_BODY), {
            fontFamily: 'Arial',
            fontSize: this.unitedBodyFontSize,
            color: '#ffffff',
            wordWrap: {
                width: this.textSpace,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let CornerPays = this.GeneratePaysTextObject(this.textSpace * 3 + this.textPadding * 4, 36 + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + CornerTextBody.displayHeight * 1.1, Client.logic.bets.betTypes[BetType.BET_CARRE].Multiplier, this.textSpace);
        playerInterfacePage.container.add(CornerTextTitle);
        playerInterfacePage.container.add(CornerTextBody);
        playerInterfacePage.container.add(CornerPays);
        //straight up
        let chip_straight = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip1_N.png");
        chip_straight.setOrigin(0.5)
        chip_straight.x = tableOffset + this.boardButtonDisplayWidth * 11.5;
        chip_straight.y = (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2.5;
        chip_straight.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
        playerInterfacePage.container.add(chip_straight);
        let straight_rectangle = new Phaser.GameObjects.Rectangle(this.scene, tableOffset + this.boardButtonDisplayWidth * 11, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2, this.boardButtonDisplayWidth, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight, 0xff9999, 0.4);
        straight_rectangle.setStrokeStyle(3, straight_rectangle.fillColor, 1.0)
        straight_rectangle.setOrigin(0, 0);
        playerInterfacePage.container.add(straight_rectangle);

        let straightTextTitle = new Phaser.GameObjects.Text(this.scene, this.textSpace * 4 + this.textPadding * 5, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_STRAIGHT_TITLE), {
            fontFamily: 'Arial',
            fontSize: this.unitedTitleFontSize,
            color: '#ff9999',
            align: 'left',
            stroke: '#ff9999',
            strokeThickness: 1,
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let straightTextBody = new Phaser.GameObjects.Text(this.scene, this.textSpace * 4 + this.textPadding * 5, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_STRAIGHT_BODY), {
            fontFamily: 'Arial',
            fontSize: this.unitedBodyFontSize,
            color: '#ffffff',
            wordWrap: {
                width: this.textSpace,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let straightPays = this.GeneratePaysTextObject(this.textSpace * 4 + this.textPadding * 5, 36 + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + straightTextBody.displayHeight * 1.1, Client.logic.bets.betTypes[BetType.BET_PLAIN].Multiplier, this.textSpace);
        playerInterfacePage.container.add(straightTextTitle);
        playerInterfacePage.container.add(straightTextBody);
        playerInterfacePage.container.add(straightPays);
        //split
        let chip_split = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip2_N.png");
        chip_split.setOrigin(0.5)
        chip_split.x = tableOffset + this.boardButtonDisplayWidth * 12;
        chip_split.y = (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight / 2;
        chip_split.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
        playerInterfacePage.container.add(chip_split);
        let split_rectangle = new Phaser.GameObjects.Rectangle(this.scene, tableOffset + this.boardButtonDisplayWidth * 11, 0, this.boardButtonDisplayWidth * 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight, 0xffff33, 0.4);
        split_rectangle.setStrokeStyle(3, split_rectangle.fillColor, 1.0)
        split_rectangle.setOrigin(0, 0);
        playerInterfacePage.container.add(split_rectangle);

        let splitTextTitle = new Phaser.GameObjects.Text(this.scene, this.textSpace * 5 + this.textPadding * 6, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_SPLIT_TITLE), {
            fontFamily: 'Arial',
            fontSize: this.unitedTitleFontSize,
            color: '#ffff33',
            align: 'left',
            stroke: '#ffff33',
            strokeThickness: 1,
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let splitTextBody = new Phaser.GameObjects.Text(this.scene, this.textSpace * 5 + this.textPadding * 6, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_SPLIT_BODY), {
            fontFamily: 'Arial',
            fontSize: this.unitedBodyFontSize,
            color: '#ffffff',
            wordWrap: {
                width: this.textSpace,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        let splitPays = this.GeneratePaysTextObject(this.textSpace * 5 + this.textPadding * 6, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + trioTextBody.displayHeight * 1.1 + 36, Client.logic.bets.betTypes[BetType.BET_CAVAL].Multiplier, this.textSpace);
        playerInterfacePage.container.add(splitTextTitle);
        playerInterfacePage.container.add(splitTextBody);
        playerInterfacePage.container.add(splitPays);
        //five/four numbers
        let chip_five = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip3_N.png");
        chip_five.setOrigin(0.5)
        chip_five.x = tableOffset + this.boardButtonDisplayWidth;
        chip_five.y = (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 3;
        chip_five.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
        playerInterfacePage.container.add(chip_five);
        let five_rectangle = new Phaser.GameObjects.Rectangle(this.scene, tableOffset, 0, this.boardButtonDisplayWidth * 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 3, 0x66ffff, 0.4);
        five_rectangle.setStrokeStyle(3, five_rectangle.fillColor, 1.0)
        five_rectangle.setOrigin(0, 0);
        playerInterfacePage.container.add(five_rectangle);

        let fiveNumbersTextTitle;
        let fiveNumbersTextBody;
        let fiveNumbersTextPays;
        if (Client.logic.IsDoubleZero()) {
            //gotta write five numbers
            fiveNumbersTextTitle = new Phaser.GameObjects.Text(this.scene, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_FIVE_NUMBERS_TITLE), {
                fontFamily: 'Arial',
                fontSize: this.unitedTitleFontSize,
                color: '#66ffff',
                align: 'center',
                stroke: '#66ffff',
                strokeThickness: 1,
                shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
            });
            fiveNumbersTextBody = new Phaser.GameObjects.Text(this.scene, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + fiveNumbersTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_FIVE_NUMBERS_BODY), {
                fontFamily: 'Arial',
                fontSize: this.unitedBodyFontSize,
                color: '#ffffff',
                align: 'left',
                wordWrap: {
                    width: this.textSpace,
                    callback: null,
                    callbackScope: null,
                    useAdvancedWrap: false
                },
                shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
            });
            fiveNumbersTextPays = this.GeneratePaysTextObject(this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + fiveNumbersTextBody.displayHeight * 1.1 + 36, Client.logic.bets.betTypes[BetType.BET_FIFTH].Multiplier, this.textSpace);

            //trio 00
            let chip_trio_doubleZero = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "chip2_N.png");
            chip_trio_doubleZero.setOrigin(0.5)
            chip_trio_doubleZero.x = tableOffset + this.boardButtonDisplayWidth;
            chip_trio_doubleZero.y = (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 1.5;
            chip_trio_doubleZero.setDisplaySize(this.boardButtonDisplayWidth / 2.25, this.boardButtonDisplayWidth / 2.25);
            playerInterfacePage.container.add(chip_trio_doubleZero);
            let trio_doubleZero_rectangle = new Phaser.GameObjects.Polygon(this.scene, tableOffset, 0, this.boardButtonDisplayWidth * 0.1 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 0.1 + " " + this.boardButtonDisplayWidth * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 0.1 + " " + this.boardButtonDisplayWidth * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight + " " + (this.boardButtonDisplayWidth * 2) * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight + " " + (this.boardButtonDisplayWidth * 2) * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2 + " " + this.boardButtonDisplayWidth * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2 + " " + this.boardButtonDisplayWidth * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 3 * 0.98 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 0.1 + " " + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 3 * 0.98, 0x99ff33, 0.4);
            trio_doubleZero_rectangle.setStrokeStyle(3, trio_doubleZero_rectangle.fillColor, 1.0);
            trio_doubleZero_rectangle.setOrigin(0, 0);
            playerInterfacePage.container.add(trio_doubleZero_rectangle);
        } else {
            //its four numbers now
            fiveNumbersTextTitle = new Phaser.GameObjects.Text(this.scene, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1, Language.Get(Messages.HELP_FOUR_NUMBERS_TITLE), {
                fontFamily: 'Arial',
                fontSize: this.unitedTitleFontSize,
                color: '#66ffff',
                align: 'left',
                stroke: '#66ffff',
                strokeThickness: 1,
                shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
            });
            fiveNumbersTextBody = new Phaser.GameObjects.Text(this.scene, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + fiveNumbersTextTitle.displayHeight * 1.1, Language.Get(Messages.HELP_FOUR_NUMBERS_BODY), {
                fontFamily: 'Arial',
                fontSize: this.unitedBodyFontSize,
                color: '#ffffff',
                align: 'left',
                wordWrap: {
                    width: this.textSpace,
                    callback: null,
                    callbackScope: null,
                    useAdvancedWrap: false
                },
                shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
            });
            fiveNumbersTextPays = this.GeneratePaysTextObject(this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5.1 + fiveNumbersTextBody.displayHeight * 1.1 + 36, Client.logic.bets.betTypes[BetType.BET_CARRE].Multiplier, this.textSpace);
        }

        playerInterfacePage.container.add(fiveNumbersTextTitle);
        playerInterfacePage.container.add(fiveNumbersTextBody);
        playerInterfacePage.container.add(fiveNumbersTextPays);
        //--Display numbers on table, and legend below------------------------------------------------
        let longestText = Math.max(fiveNumbersTextBody.displayHeight + fiveNumbersTextTitle.displayHeight + fiveNumbersTextPays.displayHeight,
            trioTextTitle.displayHeight + trioTextBody.displayHeight + trioPays.displayHeight,
            sixNumbersTextBody.displayHeight + sixNumbersTextTitle.displayHeight + sixNumbersPays.displayHeight,
            CornerTextBody.displayHeight + CornerTextTitle.displayHeight + CornerPays.displayHeight,
            splitTextBody.displayHeight + splitTextTitle.displayHeight + splitPays.displayHeight,
            straightTextBody.displayHeight + straightTextTitle.displayHeight + straightPays.displayHeight);

        //markers
        this.circleSize = this.boardButtonDisplayWidth / 2;
        //--Repeat info button stuff-----
        this.GenerateMarkersAndDescription(playerInterfacePage.container, (-this.circleSize / 2) + tableOffset, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 3, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize / 2, "1", Language.Get(Messages.HELP_REPEAT_BODY), this.textSpace * 3 - this.circleSize);
        //--Undo info button stuff-----
        this.GenerateMarkersAndDescription(playerInterfacePage.container, (-this.circleSize / 2) + tableOffset, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 4, this.textSpace * 3 + this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize / 2, "2", Language.Get(Messages.HELP_UNDO_BODY), this.textSpace * 3 - this.circleSize);
        //--Bet Presets info button stuff-----
        let thirdMarker = this.GenerateMarkersAndDescription(playerInterfacePage.container, tableOffset + this.boardButtonDisplayWidth * 14 - this.circleSize / 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 4, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize / 2 + this.textPadding + this.circleSize * 1.7, "3", Language.Get(Messages.HELP_BET_PRESETS_BODY), this.textSpace * 3 - this.circleSize);
        let thirdMarkerHeight = thirdMarker.displayHeight
        //--Toggle view button stuff-----
        let fourthMarker = this.GenerateMarkersAndDescription(playerInterfacePage.container, tableOffset + this.boardButtonDisplayWidth * 14 - this.circleSize / 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 3, this.textSpace * 3 + this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize + this.textPadding + this.circleSize * 1.7, "4", Language.Get(Messages.HELP_LAYOUT_BUTTON), this.textSpace * 3 - this.circleSize);
        let fourthMarkerHeight = fourthMarker.displayHeight
        //--Black / Red-----
        let fifthMarker = this.GenerateMarkersAndDescription(playerInterfacePage.container, 960 - this.circleSize / 2, this.circleSize / 2 + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 4, this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize / 2 + this.textPadding + this.circleSize * 1.85 + thirdMarkerHeight, "5", Language.Get(Messages.HELP_BLACK_RED), this.textSpace * 3 - this.circleSize);
        let fifthMarkerHeight = fifthMarker.displayHeight
        //-- 1to12 -----
        let sixthMarker = this.GenerateMarkersAndDescription(playerInterfacePage.container, tableOffset + this.boardButtonDisplayWidth * 14 - this.circleSize / 2, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight - this.circleSize / 2, this.textSpace * 3 + this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize + this.textPadding + this.circleSize * 1.90 + fourthMarkerHeight, "6", Language.Get(Messages.HELP_1TO12), this.textSpace * 3 - this.circleSize);
        let sixthMarkerHeight = sixthMarker.displayHeight
        // Another 6th marker without description
        this.GenerateMarkersAndDescription(playerInterfacePage.container, 960 + this.circleSize * 2, this.circleSize / 2 + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 2.90, this.textSpace * 3 + this.textPadding, (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize + this.textPadding + this.circleSize * 1.90 + fourthMarkerHeight, "6", null, this.textSpace * 3 - this.circleSize);

        //write pays under number 5
        playerInterfacePage.container.add(this.GeneratePaysTextObject(this.textPadding + this.circleSize, fifthMarkerHeight + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize / 2 + this.textPadding + this.circleSize * 1.85 + thirdMarkerHeight, Client.logic.bets.betTypes[BetType.BET_COLOR].Multiplier, this.textSpace * 3));
        //write pays under number 6
        playerInterfacePage.container.add(this.GeneratePaysTextObject(this.textSpace * 3 + this.textPadding + this.circleSize, sixthMarkerHeight + (playerInterfacePage.container.list[3] as Phaser.GameObjects.Image).displayHeight * 5 + longestText + this.circleSize + this.textPadding + this.circleSize * 1.90 + fourthMarkerHeight, Client.logic.bets.betTypes[BetType.BET_THIRD].Multiplier, this.textSpace * 3));

        playerInterfacePage.container.bringToTop(chip_straight)
        playerInterfacePage.container.bringToTop(chip_split)
        playerInterfacePage.container.bringToTop(chip_corner)
        playerInterfacePage.container.bringToTop(chip_trio)
        playerInterfacePage.container.bringToTop(chip_five)
        playerInterfacePage.container.bringToTop(chip_six)
    }

    public addPlayerTrackPage(): void {
        let playerTrackPage = new Page(() => (Language.Get(Messages.HELP_PLAYER_TRACK)), new Phaser.GameObjects.Container(this.scene, 0, 0))
        this.pages.push(playerTrackPage);

        playerTrackPage.container.setSize(1920, 1080);

        //----draw the track-------------------------
        this.trackScale = Math.min((playerTrackPage.container.height / 1.75) / (Constants.TRACK.TEXTURE_ORIGINAL_WIDTH / Constants.TRACK.TRACK_W_TO_H_RATIO), playerTrackPage.container.width / Constants.TRACK.TEXTURE_ORIGINAL_WIDTH)
        this.generalOffsetY = this.trackScale * Constants.TRACK.OFFSET_DUE_TO_ORIGIN;

        //--position track fields
        let trackImages: Array<Phaser.GameObjects.Image> = new Array<Phaser.GameObjects.Image>()
        trackImages.fill(null, 0, 38)

        let sprites = Constants.SPRITESHEET_TRACK
        let frames = "track_button_"

        let createTrackWideBetButtons = () => {
            let font = Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT

            let totalWidth = 0
            for (let i = 0; i < 4; i++) {
                let trackPresetsButton = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal)
                // let trackPresetButtonText = new Phaser.GameObjects.BitmapText(this.scene, 0, 0, Constants.BITMAP_FONTS.MONTSERRAT, '+' + (i == 3 ? "4" : i) , parseInt(font.fontSize))
                let trackPresetButtonText = new Phaser.GameObjects.Text(this.scene, 0, 0, '+' + (i == 3 ? "4" : i), Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT)
                trackPresetButtonText.setOrigin(0.5, 0.5)
                // trackPresetButtonText.setTintFill(0x39280C)
                // trackPresetButtonText.tint = 0x39280C
                trackPresetsButton.setOrigin(0, 0)
                trackPresetButtonText.setFontSize(parseInt(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT.fontSize) * 1.01)
                trackPresetsButton.setDisplaySize(this.boardButtonDisplayWidth, this.boardButtonDisplayWidth * 0.8)
                trackPresetsButton.setPosition(trackPresetsButton.displayWidth * i, 0)
                trackPresetButtonText.setPosition(trackPresetsButton.x + trackPresetsButton.displayWidth / 2, trackPresetsButton.y + trackPresetsButton.displayHeight / 2)
                playerTrackPage.container.add([trackPresetsButton, trackPresetButtonText])
                totalWidth += trackPresetsButton.displayWidth
            }

            return totalWidth
        }

        let trackWideBetButtonsWidth = createTrackWideBetButtons()

        if (Client.logic.IsDoubleZero()) {
            sprites = Constants.SPRITESHEET_TRACK_00
            frames += "00_"
        }

        this.trackNumbers.forEach(n => {
            if (n == 37 && !Client.logic.IsDoubleZero())
                return;

            let image = new Phaser.GameObjects.Image(this.scene, 0, 0, sprites, frames + n.toString() + ".png")
            trackImages[n] = image;
            playerTrackPage.container.add(image);
        });

        this.positionTrackElement(trackImages[0], 0, 0, playerTrackPage.container.width)
        if (Client.logic.IsDoubleZero()) {
            this.positionTrackElement(trackImages[2], -68.5, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[14], -135.5, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[35], -212.5, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[23], -305, 0, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[28], 68.5, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[9], 136.5, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[26], 214.5, -1, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[30], 305, -1, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[11], 399.5, 5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[7], 486.5, 29, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[20], 556, 71, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[32], 606, 124, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[17], 634, 183, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[5], 634, 252, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[22], 607.5, 312, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[34], 556.5, 364, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[15], 484.5, 407, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[3], 399.5, 432.5, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[24], 305.5, 438, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[36], 216, 438, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[13], 138, 438, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[1], 70, 438, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[37], 0, 437.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[27], -70, 437.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[10], -138, 437.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[25], -215, 437.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[29], -306, 437.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[12], -400.5, 432, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[8], -485, 407, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[19], -557, 365, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[31], -607, 313.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[18], -633, 253, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[6], -634, 183.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[21], -607.7, 124.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[33], -556, 70, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[16], -485, 30, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[4], -398, 5, playerTrackPage.container.width)
        } else {
            this.positionTrackElement(trackImages[32], 74, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[15], 143, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[19], 224, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[4], 318, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[21], 414, 6, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[26], -73, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[3], -143, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[35], -224, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[12], -318, 0, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[28], -413, 6.5, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[7], -501, 34.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[29], -571, 79.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[18], -619, 136, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[22], -641, 200, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[9], -634, 269, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[31], -599.5, 329, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[14], -540, 381, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[20], -461, 419, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[1], -368.5, 438, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[33], -273.5, 440, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[16], -185.5, 441, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[24], -109, 441, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[5], -42, 441, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[10], 40, 441, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[23], 107, 441, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[8], 182, 441, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[30], 271, 441, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[11], 367, 439, playerTrackPage.container.width)

            this.positionTrackElement(trackImages[36], 460, 419, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[13], 538, 381, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[27], 597, 330, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[6], 632, 269.5, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[34], 638, 200, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[17], 617, 136, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[25], 568, 80, playerTrackPage.container.width)
            this.positionTrackElement(trackImages[2], 500.5, 35, playerTrackPage.container.width)
        }

        let offsetFromTrackPresetButtons = 75
        let trackCenterPresetsfont = { fontFamily: Constants.BOARD.MISC_BUTTON_FONT.fontFamily }
        //--center image and texts
        let centerImage = new Phaser.GameObjects.Image(this.scene, playerTrackPage.container.width / 2, (playerTrackPage.container.height / 4) * this.trackScale + offsetFromTrackPresetButtons, sprites, "track_background.png");
        centerImage.setOrigin(0.5);
        centerImage.setDisplaySize(centerImage.displayWidth * this.trackScale, centerImage.displayHeight * this.trackScale);
        playerTrackPage.container.add(centerImage);

        let zeroGameText = new Phaser.GameObjects.Text(this.scene, playerTrackPage.container.width / 2, centerImage.y - centerImage.displayHeight / 3, Language.Get(Messages.ZERO_GAME), trackCenterPresetsfont);
        zeroGameText.setFontSize(32 * this.trackScale);
        zeroGameText.setOrigin(0.5);
        playerTrackPage.container.add(zeroGameText);

        let orphansText = new Phaser.GameObjects.Text(this.scene, playerTrackPage.container.width / 2, centerImage.y, Language.Get(Messages.ORPHANS), trackCenterPresetsfont);
        orphansText.setFontSize(32 * this.trackScale);
        orphansText.setOrigin(0.5);
        playerTrackPage.container.add(orphansText);

        if (Client.logic.IsDoubleZero()) {
            let doubleZeroGameText = new Phaser.GameObjects.Text(this.scene, playerTrackPage.container.width / 2, centerImage.y + centerImage.displayHeight / 3 + 16 * this.trackScale, Language.Get(Messages.DOUBLE_ZERO_GAME), trackCenterPresetsfont);
            doubleZeroGameText.setFontSize(32 * this.trackScale);
            doubleZeroGameText.setOrigin(0.5, 1);
            playerTrackPage.container.add(doubleZeroGameText);
        }
        else {
            zeroGameText.setPosition(playerTrackPage.container.width / 2 - zeroGameText.displayWidth / 4, centerImage.y - centerImage.displayHeight / 2 + zeroGameText.displayHeight * 2.3);
            orphansText.setPosition(playerTrackPage.container.width / 2 + centerImage.displayWidth / 3, centerImage.y - orphansText.displayHeight / 2);

            let bigSeriesText = new Phaser.GameObjects.Text(this.scene, centerImage.x - centerImage.displayWidth / 4, zeroGameText.y + zeroGameText.displayHeight * 2, Language.Get(Messages.TRACK_BIG_SERIES), trackCenterPresetsfont);
            bigSeriesText.setFontSize(32 * this.trackScale);
            bigSeriesText.setOrigin(0.5);
            playerTrackPage.container.add(bigSeriesText);

            let serie58 = new Phaser.GameObjects.Text(this.scene, playerTrackPage.container.width / 2 + centerImage.displayWidth / 7, centerImage.y + centerImage.displayHeight / 4, Language.Get(Messages.SERIE_58), trackCenterPresetsfont);
            serie58.setFontSize(32 * this.trackScale);
            serie58.setOrigin(0.5);
            playerTrackPage.container.add(serie58);
        }

        /*
        let trackWideBetRectangle = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, trackWideBetButtonsWidth, offsetFromTrackPresetButtons * 1.20, 0xFFFFFF, 0.25);
        trackWideBetRectangle.setStrokeStyle(3, trackWideBetRectangle.fillColor, 1.0)
        trackWideBetRectangle.setOrigin(0, 0);
        playerTrackPage.container.add(trackWideBetRectangle);
        */

        let trackMarkerDescriptionStartingY = (playerTrackPage.container.height / 1.75) + this.circleSize * 1.50

        //--mark track field
        this.GenerateMarkersAndDescription(playerTrackPage.container, centerImage.x - centerImage.displayWidth / 2 - 200, centerImage.y - this.circleSize * 0.7, this.textPadding, trackMarkerDescriptionStartingY, "1", Language.Get(Messages.HELP_TRACK_FIELD), this.textSpace * 3 - this.circleSize);
        //--mark cheval button
        let trackSecondMarker = this.GenerateMarkersAndDescription(playerTrackPage.container, centerImage.x - centerImage.displayWidth / 2 - this.circleSize / 1.75, centerImage.y - this.circleSize, this.textSpace * 3 + this.textPadding, trackMarkerDescriptionStartingY, "2", Language.Get(Messages.HELP_TRACK_CHEVAL), this.textSpace * 3 - this.circleSize);
        let trackSecondMarkerHeight = trackSecondMarker.displayHeight
        //--mark center presets
        this.GenerateMarkersAndDescription(playerTrackPage.container, centerImage.x + this.circleSize * 1.5, centerImage.y - this.circleSize / 2, this.textPadding, (playerTrackPage.container.height / 1.75) + this.circleSize * 1.5 + 95, "3", Language.Get(Messages.HELP_TRACK_CENTER_PRESETS), this.textSpace * 3 - this.circleSize);
        //--mark track wide bet buttons
        this.GenerateMarkersAndDescription(playerTrackPage.container, trackWideBetButtonsWidth / 2 - this.circleSize / 2, 0, this.textSpace * 3 + this.textPadding, trackSecondMarkerHeight + (playerTrackPage.container.height / 1.75) + this.circleSize * 1.6, "4", Language.Get(Messages.HELP_TRACK_WIDE_BETS), this.textSpace * 3 - this.circleSize)

    }

    public addTopPanelPage(): void {
        let topPanelPage = new Page(() => (Language.Get(Messages.HELP_TOP_PANEL)), new Phaser.GameObjects.Container(this.scene, 0, 0));
        this.pages.push(topPanelPage);

        topPanelPage.container.setSize(1920, 1080);
        //---progress bar
        let progressBar_back = new Phaser.GameObjects.Rectangle(this.scene, 0, topPanelPage.container.height / 2 - 150, topPanelPage.container.width / 6, this.boardButtonDisplayWidth * 5 / 14, Constants.PROGRESS_BAR.BACKGROUND_COLOR, 1);
        progressBar_back.setOrigin(0, 0);
        topPanelPage.container.add(progressBar_back);
        let progressBar_front = new Phaser.GameObjects.Rectangle(this.scene, progressBar_back.displayWidth, topPanelPage.container.height / 2 - 150, topPanelPage.container.width / 4 * 3, this.boardButtonDisplayWidth * 5 / 14, Constants.PROGRESS_BAR.BAR_COLOR, 1);
        progressBar_front.setOrigin(0, 0);
        topPanelPage.container.add(progressBar_front);
        let progressBar_text = new Phaser.GameObjects.Text(this.scene, topPanelPage.container.width / 2, topPanelPage.container.height / 2 - 150, Language.Get(Messages.BETS_OPEN_PLACE_BETS), {
            ...Constants.PROGRESS_BAR.FONT, fontSize: '45px', stroke: "#000", strokeThickness: 4
        });
        progressBar_text.setOrigin(0.5, 0.1);
        topPanelPage.container.add(progressBar_text);
        //---history
        let historyNumberSize = this.boardButtonDisplayWidth * 5 / 14;
        for (let i = 0; i < 38; i++) {
            let randoMcRandomly: number = Client.logic.IsDoubleZero() ? Math.round(Math.random() * 37) : Math.round(Math.random() * 36);
            let tex;
            switch (randoMcRandomly) {
                case 0:
                    tex = Assets.WinNumberHistory.SingleZeroTexture;
                    break;
                case 37:
                    tex = Assets.WinNumberHistory.DoubleZeroTexture;
                    break;
                default:
                    tex = "board_button_" + randoMcRandomly + ".png";
                    break;
            }
            let historyNumber = new Phaser.GameObjects.Image(this.scene, (historyNumberSize + Constants.WIN_NUMBER_HISTORY.HORIZONTAL_MARGIN * 2) * i, progressBar_front.y - historyNumberSize * 1.05, Constants.SPRITESHEET, tex);
            historyNumber.setDisplaySize(historyNumberSize, historyNumberSize);
            historyNumber.setOrigin(0);
            if (i == 0)
                historyNumber.x += Constants.WIN_NUMBER_HISTORY.HORIZONTAL_MARGIN;
            else
                historyNumber.x += Constants.WIN_NUMBER_HISTORY.OFFSET_FROM_FIRST_NUMBER * historyNumberSize;
            topPanelPage.container.add(historyNumber);
        }
        //---preset buttons
        for (let i = 0; i < 4; i++) {
            let presetsButton = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal)
            presetsButton.setOrigin(0, 0)
            presetsButton.setDisplaySize(this.boardButtonDisplayWidth, this.boardButtonDisplayWidth * 0.8);
            presetsButton.setPosition(this.boardButtonDisplayWidth * i, progressBar_front.y - historyNumberSize * 1.1 - presetsButton.displayHeight);

            let tex;
            let icon;
            switch (i) {
                case 0:
                    tex = Language.Get(Messages.ZERO_GAME);
                    icon = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Zero_Game_Icon.png")
                    break;
                case 1:
                    tex = Language.Get(Messages.BIG_SERIES);
                    icon = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Big_Series_Icon.png")
                    break;
                case 2:
                    tex = Language.Get(Messages.ORPHANS);
                    icon = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Orphans_Icon.png")
                    break;
                case 3:
                    tex = Language.Get(Messages.SERIE_58);
                    icon = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Serie_58_Icon.png")
                    break;
            }

            let presetText = new Phaser.GameObjects.Text(this.scene, presetsButton.x + presetsButton.displayWidth / 2, presetsButton.y + presetsButton.displayHeight / 3, tex, Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
            presetText.setOrigin(0.5);
            presetText.setFontSize(presetsButton.displayHeight / 5.5);

            icon.setOrigin(0.5)
            icon.setDisplaySize(presetsButton.displayWidth / 3, presetsButton.displayWidth / 3);
            icon.setPosition(presetsButton.x + presetsButton.displayWidth / 2, presetsButton.y + (presetsButton.displayHeight / 3) * 2);

            topPanelPage.container.add(presetsButton);
            topPanelPage.container.add(presetText);
            topPanelPage.container.add(icon);
        }
        //---betchipButtons
        let eraser = new Phaser.GameObjects.Image(this.scene, topPanelPage.container.width - (this.boardButtonDisplayWidth * 0.6) * 6.8, progressBar_front.y - historyNumberSize * 1.1 - this.boardButtonDisplayWidth * 0.8, Constants.SPRITESHEET, "chipX_new_5_D_V2.png");
        eraser.setOrigin(0)
        eraser.setDisplaySize(this.boardButtonDisplayWidth * 0.8, this.boardButtonDisplayWidth * 0.8);
        topPanelPage.container.add(eraser);

        let chip1 = new Phaser.GameObjects.Image(this.scene, eraser.x + eraser.displayWidth * 1.25, eraser.y, Constants.SPRITESHEET, "chip1_D.png");
        chip1.setOrigin(0)
        chip1.setDisplaySize(this.boardButtonDisplayWidth * 0.8, this.boardButtonDisplayWidth * 0.8);
        topPanelPage.container.add(chip1);

        let chip2 = new Phaser.GameObjects.Image(this.scene, chip1.x + chip1.displayWidth * 0.7, chip1.y, Constants.SPRITESHEET, "chip2_D.png");
        chip2.setOrigin(0)
        chip2.setDisplaySize(this.boardButtonDisplayWidth * 0.8, this.boardButtonDisplayWidth * 0.8);
        topPanelPage.container.add(chip2);

        let chip3 = new Phaser.GameObjects.Image(this.scene, chip2.x + chip2.displayWidth * 0.7, chip2.y, Constants.SPRITESHEET, "chip3_D.png");
        chip3.setOrigin(0)
        chip3.setDisplaySize(this.boardButtonDisplayWidth * 0.8, this.boardButtonDisplayWidth * 0.8);
        topPanelPage.container.add(chip3);

        let chip4 = new Phaser.GameObjects.Image(this.scene, chip3.x + chip3.displayWidth * 0.7, chip3.y, Constants.SPRITESHEET, "chip4_N.png");
        chip4.setOrigin(0)
        chip4.setDisplaySize(this.boardButtonDisplayWidth * 0.8, this.boardButtonDisplayWidth * 0.8);
        topPanelPage.container.add(chip4);

        let chip5 = new Phaser.GameObjects.Image(this.scene, chip4.x + chip3.displayWidth * 0.7, chip4.y, Constants.SPRITESHEET, "chip5_D.png");
        chip5.setOrigin(0)
        chip5.setDisplaySize(this.boardButtonDisplayWidth * 0.8, this.boardButtonDisplayWidth * 0.8);
        topPanelPage.container.add(chip5);
        //---player info panel
        let playerCreditText = new Phaser.GameObjects.Text(this.scene, 0, 0, "1.234,56 $\n" + Language.Get(Messages.BET) + ":        1,23 $\n" + Language.Get(Messages.WIN) + ":        1,23 $", {
            fontFamily: 'Arial',
            fontSize: '42px',
            color: '#ffffff',
            align: 'right'
        });
        playerCreditText.setOrigin(0);
        playerCreditText.setPosition(topPanelPage.container.width - playerCreditText.displayWidth - 64, chip5.y - playerCreditText.displayHeight);
        topPanelPage.container.add(playerCreditText);
        //lines between texts
        let line1 = new Phaser.GameObjects.Line(this.scene, 0, 0, playerCreditText.x, playerCreditText.y + playerCreditText.displayHeight / 3, playerCreditText.x + playerCreditText.displayWidth + 15, playerCreditText.y + playerCreditText.displayHeight / 3, 0xffffff, 0.3);
        line1.setOrigin(0, 0);
        line1.setLineWidth(0.5);
        topPanelPage.container.add(line1);
        let line2 = new Phaser.GameObjects.Line(this.scene, 0, 0, playerCreditText.x, playerCreditText.y + (playerCreditText.displayHeight / 3) * 2, playerCreditText.x + playerCreditText.displayWidth + 15, playerCreditText.y + (playerCreditText.displayHeight / 3) * 2, 0xffffff, 0.3);
        line2.setOrigin(0, 0);
        line2.setLineWidth(0.5);
        topPanelPage.container.add(line2);
        //player name and denom
        let playerNameAndDenom = new Phaser.GameObjects.Text(this.scene, 0, 0, "Slot Player\n1 credit = 0,01 $", {
            fontFamily: "Arial",
            color: "#999999",
            fontSize: "40px",
            align: 'right'
        });
        playerNameAndDenom.setOrigin(0);
        playerNameAndDenom.setPosition(topPanelPage.container.width - playerNameAndDenom.displayWidth - 64, chip5.y - playerCreditText.displayHeight - playerNameAndDenom.displayHeight);
        topPanelPage.container.add(playerNameAndDenom);
        //short lines between player name
        let line3 = new Phaser.GameObjects.Line(this.scene, 0, 0, playerCreditText.x + playerCreditText.displayWidth / 2, playerCreditText.y, playerCreditText.x + playerCreditText.displayWidth + 15, playerCreditText.y, 0xffffff, 1);
        line3.setOrigin(0, 0);
        line3.setLineWidth(0.5);
        topPanelPage.container.add(line3);
        let line4 = new Phaser.GameObjects.Line(this.scene, 0, 0, playerCreditText.x + playerCreditText.displayWidth / 2, playerCreditText.y - (playerNameAndDenom.displayHeight / 2), playerCreditText.x + playerCreditText.displayWidth + 15, playerCreditText.y - (playerNameAndDenom.displayHeight / 2), 0xffffff, 0.3);
        line4.setOrigin(0, 0);
        line4.setLineWidth(0.5);
        topPanelPage.container.add(line4);
        //the 3 holy credit icons gods umongst all icons the one holy truth of icons
        let icon_credits = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_WINS, "creditsIcon.png");
        icon_credits.setOrigin(0)
        icon_credits.setDisplaySize(40, 40);
        icon_credits.setPosition(topPanelPage.container.width - 40, playerCreditText.y);
        topPanelPage.container.add(icon_credits);
        let icon_bet = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_WINS, "betIcon.png");
        icon_bet.setOrigin(0)
        icon_bet.setDisplaySize(40, 40);
        icon_bet.setPosition(topPanelPage.container.width - 40, playerCreditText.y + playerCreditText.displayHeight / 3);
        topPanelPage.container.add(icon_bet);
        let icon_win = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_WINS, "winIcon.png");
        icon_win.setOrigin(0)
        icon_win.setDisplaySize(40, 40);
        icon_win.setPosition(topPanelPage.container.width - 40, playerCreditText.y + (playerCreditText.displayHeight / 3) * 2);
        topPanelPage.container.add(icon_win);

        //--progress bar markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, topPanelPage.container.width / 6 - this.circleSize / 2, topPanelPage.container.height / 2 + this.circleSize / 3 - 150, this.textPadding, topPanelPage.container.height / 2 + this.circleSize / 3 - 150 + this.circleSize * 1.25, "1", Language.Get(Messages.HELP_PROGRESS_BAR_BODY), this.textSpace * 3 - this.circleSize);
        //--progress bar text markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, progressBar_text.x - progressBar_text.displayWidth / 2 - this.circleSize * 1.10, topPanelPage.container.height / 2 + this.circleSize / 3.8 - 150, this.textSpace * 3 + this.textPadding, topPanelPage.container.height / 2 + this.circleSize / 3 - 150 + this.circleSize * 1.25, "2", Language.Get(Messages.HELP_PROGRESS_BAR_TEXT_BODY), this.textSpace * 3 - this.circleSize);
        //--preset buttons markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, 5, topPanelPage.container.height / 2 - 4 * historyNumberSize - 150, this.textPadding, topPanelPage.container.height / 2 + this.circleSize / 3 - 150 + 70 + this.textPadding + this.circleSize * 2.25, "3", Language.Get(Messages.HELP_BUTTON_PRESETS_BODY), this.textSpace * 4.5 - this.circleSize);
        //--history bar marker
        this.GenerateMarkersAndDescription(topPanelPage.container, 5, progressBar_front.y - historyNumberSize * 1.05, this.textSpace * 4.5 + this.textPadding, topPanelPage.container.height / 2 + this.circleSize / 3 - 150 + 70 + this.textPadding + this.circleSize * 2, "4", Language.Get(Messages.HELP_HISTORY_BAR), this.textSpace * 1.5 - this.circleSize);
        //--bet markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, topPanelPage.container.width - (this.circleSize + 5), topPanelPage.container.height / 2 - 4 * historyNumberSize - 150, this.textSpace * 4.5 + this.textPadding, topPanelPage.container.height / 2 + this.circleSize / 3 + 30 + this.textPadding + this.circleSize * 2.30, "5", Language.Get(Messages.HELP_BETTING_CHIPS), this.textSpace * 1.5 - this.circleSize);
        //--eraser markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, eraser.x + (this.circleSize + 5), topPanelPage.container.height / 2 - 4 * historyNumberSize - 150, this.textSpace * 4.5 + this.textPadding, topPanelPage.container.height / 2 + this.circleSize / 3 - 20 + this.textPadding + this.circleSize * 2 + 95 + this.textPadding * 18, "6", Language.Get(Messages.HELP_ERASER), this.textSpace * 1.5 - this.circleSize);
        //--player credits markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, playerCreditText.x + playerCreditText.displayWidth / 2 - this.circleSize / 2, playerCreditText.y + playerCreditText.displayHeight / 2 - this.circleSize / 2, 4.1 * this.boardButtonDisplayWidth, 15, "7", Language.Get(Messages.HELP_PLAYER_CREDITS), this.textSpace * 2.5 - this.circleSize);
        //--player name and denom markers and description
        this.GenerateMarkersAndDescription(topPanelPage.container, playerNameAndDenom.x + playerNameAndDenom.displayWidth / 2 - this.circleSize / 2, playerNameAndDenom.y + playerNameAndDenom.displayHeight / 2 - this.circleSize / 2, 4.1 * this.boardButtonDisplayWidth, 145 + this.textPadding * 15, "8", Language.Get(Messages.HELP_PLAYER_NAME_AND_DENOM), this.textSpace * 2.5 - this.circleSize);
    }

    private betsInfoPage;
    public addBetsPage(): void {
        let reload: boolean = false;

        if (!this.betsInfoPage && this.pages.indexOf(this.betsInfoPage) == -1) {
            this.betsInfoPage = new Page(() => (Language.Get(Messages.HELP_BETINFO_TITLE)), new Phaser.GameObjects.Container(this.scene, 0, 0));
            this.pages.push(this.betsInfoPage);
        } else {
            //le olde switcharoo
            let wasVisible: boolean = this.betsInfoPage.container.visible;
            reload = true;

            this.scene.children.remove(this.betsInfoPage.container);
            this.betsInfoPage.container = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.scene.children.add(this.betsInfoPage.container);

            this.betsInfoPage.container.visible = wasVisible;
            this.Resize(this.staticWidth, this.staticHeight, this.portrait);
        }

        this.betsInfoPage.container.setSize(1920, 1080);

        //--Bet type limits table-----------------
        let tableTitleFonts = {
            fontFamily: "Arial",
            align: "center",
            color: "#ffffff",
            fontStyle: "bold",
            fontSize: '42px',
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        }
        let tableFonts = {
            fontFamily: "Arial",
            align: "center",
            color: "#ffffff",
            fontSize: '42px',
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        }

        let betInfoDesc: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 960, 10, Language.Get(Messages.HELP_BETINFO_DESCRIPTION), tableFonts);
        betInfoDesc.setOrigin(0.5, 0);
        this.betsInfoPage.container.add(betInfoDesc);

        let tableGraphics: Phaser.GameObjects.Graphics = new Phaser.GameObjects.Graphics(this.scene);
        this.betsInfoPage.container.add(tableGraphics);

        let betTypes = new Map<BetType, string>([
            [BetType.BET_PLAIN, Language.Get(Messages.HELP_BETINFO_BETTYPE_PLAIN)],
            [BetType.BET_CAVAL, Language.Get(Messages.HELP_BETINFO_BETTYPE_CAVAL)],
            [BetType.BET_TRASV, Language.Get(Messages.HELP_BETINFO_BETTYPE_TRASV)],
            [BetType.BET_CARRE, Language.Get(Messages.HELP_BETINFO_BETTYPE_CARRE)],
            [BetType.BET_FIFTH, Language.Get(Messages.HELP_BETINFO_BETTYPE_FIFTH)],
            [BetType.BET_SIXTH, Language.Get(Messages.HELP_BETINFO_BETTYPE_SIXTH)],
            [BetType.BET_HLINE, Language.Get(Messages.HELP_BETINFO_BETTYPE_HLINE)],
            [BetType.BET_THIRD, Language.Get(Messages.HELP_BETINFO_BETTYPE_THIRD)],
            [BetType.BET_COLOR, Language.Get(Messages.HELP_BETINFO_BETTYPE_COLOR)],
            [BetType.BET_ODEVN, Language.Get(Messages.HELP_BETINFO_BETTYPE_ODEVN)],
            [BetType.BET_PHALF, Language.Get(Messages.HELP_BETINFO_BETTYPE_PHALF)]
        ])

        let index: number = 0;

        betTypes.forEach((betDescription, betType) => {
            if (index == 0) {
                let betTitle: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 460, 100, Language.Get(Messages.HELP_BETINFO_BET_TYPE), tableTitleFonts);
                let minBetTitle: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 960, 100, Language.Get(Messages.HELP_BETINFO_MIN_BET), tableTitleFonts);
                let maxBetTitle: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 1460, 100, Language.Get(Messages.HELP_BETINFO_MAX_BET), tableTitleFonts);

                betTitle.setOrigin(0.5, 0);
                minBetTitle.setOrigin(0.5, 0);
                maxBetTitle.setOrigin(0.5, 0);

                this.betsInfoPage.container.add(betTitle);
                this.betsInfoPage.container.add(minBetTitle);
                this.betsInfoPage.container.add(maxBetTitle);

                tableGraphics.lineStyle(2, 0xffffff, 1);
                tableGraphics.lineBetween(240, 150, 1700, 150);
            }

            index++;

            if (index % 2 == 0) {
                tableGraphics.fillStyle(0xffffff, 0.15);
                tableGraphics.fillRoundedRect(360 - 120, 100 + (index * 50), 1200 + 260, 50, 3);
            }

            let betName: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 460, 100 + (index * 50), betDescription, tableFonts).setOrigin(0.5, 0);

            let betMinText = "";
            if (Client.logic.Stake.getMinBet(betType) == 0)
                betMinText = Language.Get(Messages.TABLE_NO_MINIMUM);
            else
                betMinText = Client.logic.Stake.getMinBet(betType).toString();

            let betMaxText = "";
            if (Client.logic.Stake.getMaxBet(betType) == 0)
                betMaxText = Language.Get(Messages.TABLE_NO_MAXIMUM);
            else
                betMaxText = Client.logic.Stake.getMaxBet(betType).toString();

            let betMin: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 960, 100 + (index * 50), betMinText, tableFonts).setOrigin(0.5, 0);
            let betMax: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 1460, 100 + (index * 50), betMaxText, tableFonts).setOrigin(0.5, 0);

            this.betsInfoPage.container.add(betName);
            this.betsInfoPage.container.add(betMin);
            this.betsInfoPage.container.add(betMax);
        });

        //--Playboard limits display------------------
        let betMinText;
        if (Client.logic.Stake.PlayBoardLimitMin == 0)
            betMinText = () => (Language.Get(Messages.HELP_BETINFO_NO_MIN_TABLE_BET));
        else
            betMinText = () => (Language.Get(Messages.HELP_BETINFO_MIN_TABLE_BET) + " " + Client.logic.Stake.PlayBoardLimitMin.toString());

        let betMaxText;
        if (Client.logic.Stake.PlayBoardLimitMax == 0)
            betMaxText = () => (Language.Get(Messages.HELP_BETINFO_NO_MAX_TABLE_BET));
        else
            betMaxText = () => (Language.Get(Messages.HELP_BETINFO_MAX_TABLE_BET) + " " + Client.logic.Stake.PlayBoardLimitMax.toString());

        let minTableBet: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 960, 100 + ((index + 2) * 50), betMinText(), tableFonts).setOrigin(0.5, 0);
        this.betsInfoPage.container.add(minTableBet);
        minTableBet.setData('message', () => (betMinText()))
        minTableBet.setData('maxWidthAndHeight', { width: minTableBet.displayWidth, height: minTableBet.displayHeight })

        let maxTableBet: Phaser.GameObjects.Text = new Phaser.GameObjects.Text(this.scene, 960, 100 + ((index + 3) * 50), betMaxText(), tableFonts).setOrigin(0.5, 0);
        this.betsInfoPage.container.add(maxTableBet);
        maxTableBet.setData('message', () => (betMaxText()))
        maxTableBet.setData('maxWidthAndHeight', { width: maxTableBet.displayWidth, height: maxTableBet.displayHeight })

        tableGraphics.fillStyle(0xffffff, 0.15);
        tableGraphics.strokeRoundedRect(
            960 - Math.max(minTableBet.displayWidth / 2, maxTableBet.displayWidth / 2) - 25,
            minTableBet.y - 25,
            Math.max(minTableBet.displayWidth, maxTableBet.displayWidth) + 50,
            minTableBet.displayHeight * 2 + 50,
            30
        );
        this.betsInfoPage.container.add(tableGraphics);

        if (reload) {
            this.Resize(this.staticWidth, this.staticHeight, this.portrait);
        }

        // * UPDATE ON CHANGED STAKE
        this.scene.game.events.on(Constants.EVENTS.STAKE_CHANGED, () => {
            this.addBetsPage();
        });
    }

    public addExtrasPage(): void {
        let extrasPage = new Page(() => (Language.Get(Messages.HELP_EXTRAS)), new Phaser.GameObjects.Container(this.scene, 0, 0));
        this.pages.push(extrasPage);
        extrasPage.container.setSize(1920, 1080);

        let companyLogo = new Phaser.GameObjects.Image(this.scene, extrasPage.container.width / 2, 50, Constants.SPRITESHEET_MENU, "Logo_IMAXA.png");
        companyLogo.setDisplaySize(companyLogo.displayWidth * 1.5, companyLogo.displayHeight * 1.5);
        companyLogo.setOrigin(0.5, 0);
        extrasPage.container.add(companyLogo);

        let linee = new Phaser.GameObjects.Line(this.scene, 0, 0, companyLogo.x - 50, companyLogo.y + companyLogo.displayHeight * 1.1, companyLogo.x + 50, companyLogo.y + companyLogo.displayHeight * 1.1, 0xffffff, 1);
        linee.setOrigin(0, 0);
        linee.setLineWidth(0.5);
        extrasPage.container.add(linee);

        let disconnectionPolicy = new Phaser.GameObjects.Text(this.scene, companyLogo.x, companyLogo.y + companyLogo.displayHeight * 1.2, Language.Get(Messages.HELP_DISCONNECTION_POLICY), {
            fontFamily: 'Arial',
            fontSize: '34px',
            color: '#ffffff',
            align: 'center',
            wordWrap: {
                width: this.textSpace * 5,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        disconnectionPolicy.setOrigin(0.5, 0);
        extrasPage.container.add(disconnectionPolicy)

        let lineee = new Phaser.GameObjects.Line(this.scene, 0, 0, companyLogo.x - 50, companyLogo.y + companyLogo.displayHeight * 1.2 + disconnectionPolicy.displayHeight * 1.5, companyLogo.x + 50, companyLogo.y + companyLogo.displayHeight * 1.2 + disconnectionPolicy.displayHeight * 1.5, 0xffffff, 1);
        lineee.setOrigin(0, 0);
        lineee.setLineWidth(0.5);
        extrasPage.container.add(lineee);

        let errorHandling = new Phaser.GameObjects.Text(this.scene, companyLogo.x, companyLogo.y + companyLogo.displayHeight * 1.2 + disconnectionPolicy.displayHeight * 2, Language.Get(Messages.HELP_ERROR_HANDLING), {
            fontFamily: 'Arial',
            fontSize: '34px',
            color: '#ffffff',
            align: 'center',
            wordWrap: {
                width: disconnectionPolicy.displayWidth,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
        });
        errorHandling.setOrigin(0.5, 0);
        extrasPage.container.add(errorHandling)
    }

    public addLuckyJackpotPage(): void {
        if (this.hasJackpotPage)
            return;

        let jackpotPage = new Page(() => (Language.Get(Messages.HELP_JACKPOT)), new Phaser.GameObjects.Container(this.scene, 0, 0));
        jackpotPage.container.setSize(1920, 1080);
        this.pages.splice(this.pages.length - 2, 0, jackpotPage); //insert jackpot page before the final two pages, we want "extras" to be last

        // * GOLD JACKPOT
        // let jackpot_gold_background = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_JACKPOT_LEVEL_BACKGROUND, "1.png");
        let jackpot_gold_background = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "jackpotBackgroundShine")
        jackpot_gold_background.setOrigin(0)
        jackpot_gold_background.setTint(0xf7e8a2, 0xf1d55b, 0xebc314, 0xd3b012);
        jackpot_gold_background.setPosition(50, 50);
        jackpot_gold_background.setDisplaySize(jackpot_gold_background.width * 2.5, jackpot_gold_background.height * 2.5);
        jackpot_gold_background.play("jackpotBackgroundShine");
        jackpot_gold_background.addToUpdateList();
        jackpotPage.container.add(jackpot_gold_background);

        let jackpot_gold_title = new Phaser.GameObjects.BitmapText(this.scene, jackpot_gold_background.x + jackpot_gold_background.displayWidth / 2, jackpot_gold_background.y + jackpot_gold_background.displayHeight / 4 + 25, 'jackpotTitle', "JACKPOT GOLD", 32);
        jackpot_gold_title.setOrigin(0.5);
        jackpot_gold_title.setTint(0xf7e8a2, 0xf1d55b, 0xebc314, 0xd3b012);
        jackpotPage.container.add(jackpot_gold_title);

        let jackpot_gold_amount = new Phaser.GameObjects.BitmapText(this.scene, jackpot_gold_background.x + jackpot_gold_background.displayWidth / 2, jackpot_gold_background.y + jackpot_gold_background.displayHeight / 2 + 6, 'jackpotSilver', "123,456.78 EUR", 64);
        jackpot_gold_amount.setOrigin(0.5);
        jackpot_gold_amount.setTint(0xf7e8a2, 0xf1d55b, 0xebc314, 0xd3b012);
        jackpotPage.container.add(jackpot_gold_amount);



        // * SILVER JACKPOT
        let jackpot_silver_background = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "jackpotBackgroundShine")
        jackpot_silver_background.setOrigin(0)
        jackpot_silver_background.setPosition(jackpot_gold_background.x, jackpot_gold_background.y + jackpot_gold_background.displayHeight / 2.25);
        jackpot_silver_background.setDisplaySize(jackpot_silver_background.width * 2.5, jackpot_silver_background.height * 2.5);
        jackpot_silver_background.play("jackpotBackgroundShine");
        // jackpot_silver_background.playAfterDelay("jackpotBackgroundShine", 300);
        jackpot_silver_background.addToUpdateList();
        jackpotPage.container.add(jackpot_silver_background);


        let jackpot_silver_title = new Phaser.GameObjects.BitmapText(this.scene, jackpot_silver_background.x + jackpot_silver_background.displayWidth / 2, jackpot_silver_background.y + jackpot_silver_background.displayHeight / 4 + 25, 'jackpotTitle', "JACKPOT SILVER", 32);
        jackpot_silver_title.setOrigin(0.5);
        jackpotPage.container.add(jackpot_silver_title);

        let jackpot_silver_amount = new Phaser.GameObjects.BitmapText(this.scene, jackpot_silver_background.x + jackpot_silver_background.displayWidth / 2, jackpot_silver_background.y + jackpot_silver_background.displayHeight / 2 + 6, 'jackpotSilver', "123,456.78 EUR", 64);
        jackpot_silver_amount.setOrigin(0.5);
        jackpotPage.container.add(jackpot_silver_amount);

        // * NUMBERS AND MARKERS
        let myNum = 4;
        let numColumns = 5;
        let totalNums = 15;
        let jackpotMarker;
        for (let i = 0; i < numColumns; i++) {
            for (let j = totalNums / numColumns; j > 0; j--) {
                let field = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "board_button_" + myNum + ".png")
                field.setOrigin(0, 0);
                field.alpha = 1 - (Math.abs((i + 1) - (numColumns + 1) / 2) / numColumns) * 1.9;
                field.setPosition(this.boardButtonDisplayWidth * (1 + i) + jackpotPage.container.width / 2 - 50, (this.boardButtonDisplayWidth * (field.displayHeight / field.displayWidth)) * (j - 1) + jackpotPage.container.height / 2 - 150);
                field.setDisplaySize(this.boardButtonDisplayWidth, this.boardButtonDisplayWidth * (field.displayHeight / field.displayWidth));
                jackpotPage.container.add(field);

                // top it all off with the juicy marker at the center
                if (myNum == 11) {
                    jackpotMarker = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "jackpotNumberMarker")
                    jackpotMarker.addToUpdateList();
                    jackpotMarker.play("jackpotNumberMarker");
                    jackpotMarker.setOrigin(0.5)
                    jackpotMarker.setTint(0xf1d55b);
                    jackpotMarker.setDisplaySize(field.displayWidth * 1.7, field.displayWidth * 1.7);
                    jackpotMarker.setPosition(field.x + field.displayWidth / 2, field.y + field.displayHeight / 2);
                    jackpotPage.container.add(jackpotMarker);
                }
                myNum++;
            }
        }

        //--jackpot level markers and description
        this.GenerateMarkersAndDescription(jackpotPage.container, jackpot_gold_background.x + jackpot_gold_background.displayWidth * 0.71, jackpot_gold_background.y + this.circleSize, jackpot_gold_background.x + jackpot_gold_background.displayWidth, jackpot_gold_background.y + this.circleSize, "1", Language.Get(Messages.HELP_JACKPOT_LEVEL), this.textSpace * 2.2 - this.circleSize);
        //--jackpot marker markers and description
        this.GenerateMarkersAndDescription(jackpotPage.container, jackpotMarker.x - this.circleSize * 2, jackpotMarker.y - this.circleSize, 260, jackpotMarker.y - this.circleSize, "2", Language.Get(Messages.HELP_JACKPOT_MARKER), this.textSpace * 2.2 - this.circleSize);

        // * ADD PAGE AND SUBTITLE
        let injectionIndex = this.subTitles.length - 2;
        this.subTitles.splice(injectionIndex, 0, new Phaser.GameObjects.Text(this.scene, 0, 0, jackpotPage.getPageName(), {
            fontFamily: 'Arial',
            fontSize: '42px',
            color: '#ffffff',
            align: 'center'
        }));
        this.subTitles[injectionIndex].setInteractive();
        this.subTitles[injectionIndex].on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            pointer.event.stopPropagation();
            if (this.activePage != injectionIndex) {
                this.scene.sound.play(Constants.SOUNDS.CHIP_SELECT, { volume: 0.45 * effectsVolume });
                this.activePage = injectionIndex;
                this.UpdateSubtitle();
            }
        }, this);
        this.subTitles[injectionIndex].visible = false;

        this.scene.children.add(this.subTitles[injectionIndex]);
        this.scene.children.add(jackpotPage.container);
        jackpotPage.container.visible = false;

        this.UpdateSubtitle();
        this.Resize(this.staticWidth, this.staticHeight, this.portrait);

        let lastTwoPages = [this.pages[this.pages.length - 2], this.pages[this.pages.length - 1]]

        lastTwoPages.forEach((page, index) => {
            this.subTitles[index + this.pages.length - 2].on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
                event.stopPropagation();
                pointer.event.stopPropagation();
                event.stopPropagation();

                if (this.activePage != index + this.pages.length - 2) {
                    this.scene.sound.play(Constants.SOUNDS.CHIP_SELECT, { volume: 0.45 * effectsVolume });
                    this.activePage = index + this.pages.length - 2;
                    this.UpdateSubtitle();
                }
            }, this);
        });
    }

    protected GeneratePaysTextObject(x: number, y: number, payout: number, textSpace: number): Phaser.GameObjects.Text {
        let text = Language.Get(Messages.HELP_PAYS)[0].toUpperCase() + Language.Get(Messages.HELP_PAYS).slice(1) + " " + payout + " x " + Language.Get(Messages.BET).toLocaleLowerCase()

        let paysObj = new Phaser.GameObjects.Text(this.scene, x, y, text, {
            fontFamily: 'Arial',
            fontSize: this.unitedBodyFontSize,
            color: '#FF0000',
            align: 'left',
            stroke: '#FF0000',
            strokeThickness: 1,
            wordWrap: {
                width: textSpace,
                callback: null,
                callbackScope: null,
                useAdvancedWrap: false
            },
            shadow: { offsetX: 2, offsetY: 2, color: '#000000', fill: true }
        });
        paysObj.setData('message', () => (Language.Get(Messages.HELP_PAYS)[0].toUpperCase() + Language.Get(Messages.HELP_PAYS).slice(1) + " " + payout + " x " + Language.Get(Messages.BET).toLocaleLowerCase()))
        return paysObj
    }

    protected GenerateMarkersAndDescription(container: Phaser.GameObjects.Container, tableMarkerX: number, tableMarkerY: number, descriptionMarkerX: number, descriptionMarkerY: number, descriptionNumber: string, descriptionText = null, spaceTextTakes: number) {
        //make a circle on the table or image
        let tableMarkerBackground = new Phaser.GameObjects.Ellipse(this.scene, tableMarkerX, tableMarkerY, this.circleSize, this.circleSize, 0xFF0000, 1);
        tableMarkerBackground.setOrigin(0);
        container.add(tableMarkerBackground);
        //draw a number in it
        let tableMarkerNumber = new Phaser.GameObjects.Text(this.scene, tableMarkerBackground.x + tableMarkerBackground.displayWidth / 2, tableMarkerBackground.y + tableMarkerBackground.displayHeight / 2, descriptionNumber, {
            fontFamily: 'Arial',
            fontSize: '38px',
            color: '#ffffff',
            align: 'center'
        });
        tableMarkerNumber.setOrigin(0.5);
        container.add(tableMarkerNumber);
        //now do the same on the bottom part of the help next to the texts
        let descriptionMarkerBackground = new Phaser.GameObjects.Ellipse(this.scene, descriptionMarkerX, descriptionMarkerY, this.circleSize, this.circleSize, 0xFF0000, 1);
        descriptionMarkerBackground.setOrigin(0);
        container.add(descriptionMarkerBackground);

        let descriptionMarkerNumber = new Phaser.GameObjects.Text(this.scene, descriptionMarkerBackground.x + descriptionMarkerBackground.displayWidth / 2, descriptionMarkerBackground.y + descriptionMarkerBackground.displayHeight / 2, descriptionNumber, {
            fontFamily: 'Arial',
            fontSize: '42px',
            color: '#ffffff',
            align: 'center'
        });
        descriptionMarkerNumber.setOrigin(0.5);
        container.add(descriptionMarkerNumber);

        //text itself
        if (descriptionText) {
            let descriptionTextElement = new Phaser.GameObjects.Text(this.scene, descriptionMarkerBackground.x + descriptionMarkerBackground.displayWidth + this.textPadding, descriptionMarkerBackground.y, descriptionText, {
                fontFamily: 'Arial',
                fontSize: '34px',
                color: '#ffffff',
                align: 'left',
                wordWrap: {
                    width: spaceTextTakes,
                    callback: null,
                    callbackScope: null,
                    useAdvancedWrap: false
                },
                shadow: { offsetX: 2, offsetY: 2, color: '#000000', fill: true }
            });
            descriptionTextElement.setData('message', () => (descriptionText()))
            container.add(descriptionTextElement);
            return descriptionTextElement
        } else {
            let descriptionTextElement = new Phaser.GameObjects.Text(this.scene, 0, 0, '', {
                fontFamily: 'Arial',
                fontSize: '36px',
                color: '#ffffff',
                align: 'left',
                wordWrap: {
                    width: spaceTextTakes,
                    callback: null,
                    callbackScope: null,
                    useAdvancedWrap: false
                },
                shadow: { offsetX: 3, offsetY: 3, color: '#000000', fill: true }
            })
            descriptionTextElement.displayHeight = 0
            return descriptionTextElement
        }
    }

    protected positionTrackElement(image: Phaser.GameObjects.Image, x: number, y: number, maxWidth: number): void {
        let offsetFromPresetButtons = 75
        image.setPosition(maxWidth / 2 + this.trackScale * x, y * this.trackScale + this.generalOffsetY + offsetFromPresetButtons);
        image.setDisplaySize(image.displayWidth * this.trackScale, image.displayHeight * this.trackScale);
    }
}
